import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { IconX } from '@tabler/icons-react'

const Event = forwardRef(
  function Events(props, ref) {
    const [title, setTitle] = useState("");
    const [isOpen, setIsOpen] = useState("");
    const [eventDate, setEventDate] = useState("");
    const [eventTime, setEventTime] = useState("");
    const [venue, setVenue] = useState("");
    const [locationUrl, setLocationUrl] = useState("");
    const [errors, setErrors] = useState({});
    const [showDelete, setShowDelete] = useState(false);

    useEffect(() => {
      if (props.data) {
        setTitle(props.data.title);
        setIsOpen(props.data.show);
        setEventDate(props.data.date);
        setEventTime(props.data.time);
        setVenue(props.data.venue);
        setLocationUrl(props.data.location);
      }
    }, [props.data])

    useEffect(() => {
      setIsOpen(props.data.show);
    }, [props.data.show]);

    useEffect(() => {
      setShowDelete(props.showDelete);
    }, [props.showDelete]);


    const validate = () => {
      const errors = {};

      if (!title || (title && title.trim() == "")) {
        errors.title = "Event name is required";
      }

      if (!eventDate || (eventDate && eventDate.trim() == "")) {
        errors.eventDate = "Event date is required";
      }

      if (!eventTime || (eventTime && eventTime.trim() == "")) {
        errors.eventTime = "Time of event is required";
      }

      if (!venue || (venue && venue.trim() == "")) {
        errors.venue = "Venue address is required";
      }

      setErrors(errors);
      return Object.keys(errors).length === 0;
    }

    const getData = () => {
      return {
        title: title,
        date: eventDate,
        time: eventTime,
        venue: venue,
        location: locationUrl
      }
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
      <div className="card accordion-item ">
        <h2 className="accordion-header">
          <button type="button"
            onClick={() => props.showHideEvent(props.index)}
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}>
            {title}
          </button>
        </h2>

        <div className={`accordion-collapse ${isOpen ? "show" : "collapse"}`}>
          <div className="accordion-body mt-3">
            <div className="row">
              <div className="col-lg-8 col-12">
                <div className="row">
                  <div className="col-md-6 mt-2">
                    <label className="form-label required">
                      Event Name
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.title ? "is-invalid" : ""}`}
                      placeholder="Enter event name"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                    {errors.title && (
                      <div className="invalid-feedback">
                        {errors.title}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mt-2">
                    <label className="form-label required">
                      Event Date
                    </label>
                    <input
                      type="date"
                      className={`form-control ${errors.eventDate ? "is-invalid" : ""}`}
                      placeholder="Select event date"
                      data-date-format="dd-mm-yyyy"
                      value={eventDate}
                      onChange={(e) => setEventDate(e.target.value)}
                    />
                    {errors.eventDate && (
                      <div className="invalid-feedback">
                        {errors.eventDate}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mt-2">
                    <label className="form-label required">
                      Time Of Event
                    </label>
                    <input
                      type="time"
                      className={`form-control ${errors.eventTime ? "is-invalid" : ""}`}
                      placeholder="Select time of event"
                      data-date-format="HH-mm"
                      value={eventTime}
                      onChange={(e) => setEventTime(e.target.value)}
                    />
                    {errors.eventTime && (
                      <div className="invalid-feedback">
                        {errors.eventTime}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mt-2">
                    <label className="form-label">
                      Venue Location Url
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter venue location url"
                      value={locationUrl}
                      onChange={(e) => setLocationUrl(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <label className="form-label required">
                  Venue Address
                </label>
                <textarea
                  style={{ height: "110px", resize: "none" }}
                  className={`form-control ${errors.venue ? "is-invalid" : ""}`}
                  placeholder="Enter venue address"
                  value={venue}
                  onChange={(e) => setVenue(e.target.value)}></textarea>
                {errors.venue && (
                  <div className="invalid-feedback">
                    {errors.venue}
                  </div>
                )}
              </div>
            </div>
            {showDelete && (
              <div className="col-12 mt-3">
                <button type="button" className="btn btn-label-danger"
                  onClick={() => props.deleteEvent(props.index)}>
                  <IconX className="me-1" size={16} />
                  <span className="align-middle">Delete</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  });

export default Event;
